/* =========================================================
   ATCF custom-script.js — tidied 5 Nov
   Removed: Slick related-products slider (no slider on the site),
   old tmenu watermark fix, Globo filter / quick-view add-to-cart
   handlers and the "Quick view" text watcher (Globo removed),
   commented-out experiments.
   ========================================================= */

jQuery(document).ready(function ($) {
  /* Testimonials page: show 3 at a time with "Load more" */
  var testimonialsToShow = 3;
  var $testimonials = $(".client-item");
  var $loadMoreBtn = $(".load-more");
  var totalTestimonials = $testimonials.length;

  if (totalTestimonials) {
    $testimonials.hide().slice(0, testimonialsToShow).show();
    if (totalTestimonials <= testimonialsToShow) {
      $loadMoreBtn.hide();
    }
    $loadMoreBtn.on("click", function (e) {
      e.preventDefault();
      testimonialsToShow += 3;
      $testimonials.slice(0, testimonialsToShow).slideDown();
      if (testimonialsToShow >= totalTestimonials) {
        $loadMoreBtn.hide();
      }
    });
  }

  /* Shop by category carousel (Owl only loads where that section is used) */
  if ($.fn.owlCarousel && $(".category-items-carousel").length) {
    $(".category-items-carousel").owlCarousel({
      items: 4.4,
      loop: true,
      margin: 20,
      dots: false,
      nav: true,
      autoplay: 0,
      autoHeight: true,
      autoplayTimeout: 8000,
      autoplaySpeed: 3000,
      smartSpeed: 800,
      responsive: {
        0: { items: 1 },
        480: { items: 1 },
        767: { items: 2 },
        991: { items: 3 },
        1199: { items: 4.4 }
      }
    });
  }
});

/* FAQ accordions (collection FAQs, FAQ page) */
jQuery(".faq-item-title").on("click", function () {
  jQuery(this).hasClass("active")
    ? (jQuery(this).removeClass("active"),
      jQuery(this).siblings(".faq-title-content").slideUp(200))
    : (jQuery(".faq-item-title").removeClass("active"),
      jQuery(this).addClass("active"),
      jQuery(".faq-title-content").slideUp(200),
      jQuery(this).siblings(".faq-title-content").slideDown(200));
});

/* Product page tabs: show the first tab and hide the rest */
$(".tabs-nav li:first-child").addClass("active");
$(".tab-content").hide();
$(".tab-content:first").show();

$(".tabs-nav li").click(function () {
  $(".tabs-nav li").removeClass("active");
  $(this).addClass("active");
  $(".tab-content").hide();
  var activeTab = $(this).find("a").attr("href");
  $(activeTab).fadeIn();
  return false;
});

/* Cart drawer "Continue shopping" goes back to the last page.
   Works even after the drawer is refreshed (was an error on pages without the button). */
document.referrer && localStorage.setItem("lastPage", document.referrer);
document.addEventListener("click", function (event) {
  if (event.target.closest("#continue-shopping-btn")) {
    window.location.href = localStorage.getItem("lastPage") || "/";
  }
});

/* Product page size chart: click an image to view it full screen */
document.addEventListener("DOMContentLoaded", function () {
  var images = document.querySelectorAll(".size-chart-image img, .size-chart-image img.spec-image");
  images.forEach(function (img) {
    img.addEventListener("click", function () {
      var fullscreenContainer = document.createElement("div");
      fullscreenContainer.classList.add("fullscreen-container");

      var fullscreenImg = document.createElement("img");
      fullscreenImg.src = img.src;
      fullscreenImg.classList.add("fullscreen-img");

      var closeButton = document.createElement("button");
      closeButton.innerHTML = "✖";
      closeButton.classList.add("close-button");

      fullscreenContainer.appendChild(fullscreenImg);
      fullscreenContainer.appendChild(closeButton);
      document.body.appendChild(fullscreenContainer);

      closeButton.addEventListener("click", function () {
        document.body.removeChild(fullscreenContainer);
      });
      fullscreenContainer.addEventListener("click", function (e) {
        if (e.target === fullscreenContainer) {
          document.body.removeChild(fullscreenContainer);
        }
      });
    });
  });
});

/* Knives in the cart: checkout stays disabled until the age/agree box is ticked */
(function () {
  var targetNode = document.querySelector(".cart-drawer");
  if (!targetNode) return;

  var observerCart = new MutationObserver(function () {
    if (document.querySelector(".knives_checkbox_wrapper")) {
      var agreeCheckboxes = document.querySelectorAll(".agree-checkbox");
      var checkoutButtons = document.querySelectorAll(".cart__checkout-button");
      checkoutButtons.forEach(function (checkoutButton) { checkoutButton.disabled = true; });

      agreeCheckboxes.forEach(function (agreeCheckbox) {
        agreeCheckbox.addEventListener("change", function () {
          var checked = this.checked;
          checkoutButtons.forEach(function (checkoutButton) { checkoutButton.disabled = !checked; });
        });
      });
    }
  });
  observerCart.observe(targetNode, { childList: true, subtree: true });
})();